// countrySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import DropdownService from "src/services/DropdownService"

export const fetchCountries = createAsyncThunk(
  "country/fetchCountries",
  async (type, { rejectWithValue }) => {
    try {
      const res = await DropdownService.getAllCountries({ type })
      return { type, data: res.success || [] }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Fetch failed")
    }
  }
)

const countrySlice = createSlice({
  name: "country",
  initialState: {
    dataByType: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchCountries.pending, state => {
        state.loading = true
      })
      .addCase(fetchCountries.fulfilled, (state, action) => {
        const { type, data } = action.payload
        state.dataByType[type] = data
        state.loading = false
      })
      .addCase(fetchCountries.rejected, (state, action) => {
        state.error = action.payload
        state.loading = false
      })
  },
})

export default countrySlice.reducer
